import { useState, Fragment, useEffect, useRef, useContext, PropsWithChildren } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

import flex from "../../styles/flex";
import NavigationMenu from '../../components/navigationMenu/NavigationMenu';
import Header from './components/header/Header';
import HeaderV2 from './components/header/Header_v2';
import styles from './styles';
import SearchResults from './components/search/components/results/SearchResults';
import { SearchContext } from './components/search/searchBooking';
import { retrieveObject, retrieveValue } from '../../utility/storage';
import { SessionContext } from '../../utility/useSession';
import { ReleaseFlag, useReleaseManagement } from '../../utility/feature-management';

const DashPage = (props: PropsWithChildren<{
  absoluteChildren?: React.ReactNode,
  noScroll?: boolean
}>) => {
  const session = useContext(SessionContext);
  const [showNav, setShowNav] = useState(false);

  const theme = useTheme();
  const isLargeDevice = useMediaQuery(theme.breakpoints.up('md'));

  const headerRef = useRef<HTMLDivElement>(null);
  const navBarRef = useRef<HTMLDivElement>(null);
  const pageContainerRef = useRef<HTMLDivElement>(null);

  const [headerHeight, setHeaderHeight] = useState<number>(0);
  const [navBarHeight, setNavBarHeight] = useState<number>(0);

  const isNewHeaderReleased = useReleaseManagement(ReleaseFlag.releaseHeaderV2);

  const defaultSearch = {
    search: "",
    exact: false,
    cancelled: false,
  };

  const [searchCritiera, setSearchCritiera] = useState(
    retrieveValue("storeSearch", "1") == "1" ? {
      ...retrieveObject("search", defaultSearch), show: false
    } : { ...defaultSearch, show: false });

  useEffect(() => {
    if (headerRef.current != null) {
      const headerRect = headerRef.current.getBoundingClientRect();
      setHeaderHeight(headerRect.height);
      if (navBarRef.current != null) {
        setNavBarHeight(navBarRef.current.scrollHeight);
      }
    }
  }, [headerRef, showNav, searchCritiera, isLargeDevice]);


  if (session.current.site == null || session.current.site.home == null) {
    return <Fragment></Fragment>;
  }

  //const absolute = searchCritiera.text.length == 0 ? props.absoluteChildren == null : false;

  return (<SearchContext.Provider value={{
    criteria: searchCritiera,
    setCriteria: setSearchCritiera
  }}>
    <div style={styles.rootContainer}>
      <div style={styles.rootContainerRelative}>
        <div style={styles.rootContainerLayout}>
          <div ref={navBarRef} className={"hidden-scroll"} style={{ ...styles.navBar, display: (isLargeDevice == true || showNav == true) ? "block" : "none" }}>
            <NavigationMenu isLargeDevice={isLargeDevice} showNav={showNav} setShowNav={(b) => setShowNav(b)} />
          </div>

          <div style={styles.mainContainer}>
            <div style={styles.mainContainerFlex}>
              <div ref={headerRef} style={flex.flexAuto}>
                {isNewHeaderReleased ?
                  <HeaderV2
                    showNav={showNav}
                    setShowNav={(b) => setShowNav(b)}
                  /> :
                  <Header
                    showNav={showNav}
                    setShowNav={(b) => setShowNav(b)}
                  />
                }
              </div>
              <div style={flex.flexFill}>
                <div style={styles.pageWrapper}>
                  <Fragment>{props.absoluteChildren}</Fragment>
                  <div ref={pageContainerRef} style={props.noScroll == true ? styles.pageContainerNoScroll : styles.pageContainer}
                    onScroll={() => {
                      if (pageContainerRef.current != null && navBarRef.current != null) {
                        navBarRef.current.scrollTo(0, pageContainerRef.current.scrollTop);
                      }
                    }}>
                    <div style={{ ...styles.navBarSpacer, top: (-headerHeight) }} >
                      <div style={{ height: navBarHeight, width: 1 }}></div>
                    </div>
                    <Fragment>{props.children}</Fragment>
                  </div>
                  <SearchResults></SearchResults>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </SearchContext.Provider>);

}

export default DashPage;
